<template>
  <container ref="container">
    <slot v-if="isSet"></slot>
  </container>
</template>

<script>
import throttle from 'lodash/throttle';
import ResizeObserver from 'resize-observer-polyfill';

import { Container } from './parentSize.styles';

export default {
  components: { Container },
  data() {
    return {
      isSet: false,
    };
  },
  methods: {
    resize: throttle(function({ width, height }) {
      this.$emit('resize', [width, height]);
    }, 100),
  },
  mounted() {
    this.resizeObserver = new ResizeObserver((entries = [] /** , observer */) => {
      entries.forEach(entry => {
        const { width, height } = entry.contentRect;

        this.animationFrameID = window.requestAnimationFrame(() => {
          this.$emit('resize', [width, height]);
          this.isSet = true;
        });
      });
    });

    const target = this.$refs.container.$el;

    if (target) this.resizeObserver.observe(target);
  },
  beforeDestroy() {
    window.cancelAnimationFrame(this.animationFrameID);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
};
</script>
